import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=0f1f99ac&scoped=true&"
import script from "./ReviewPage.vue?vue&type=script&lang=js&"
export * from "./ReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=0f1f99ac&prod&scoped=true&lang=css&"
import style1 from "./ReviewPage.vue?vue&type=style&index=1&id=0f1f99ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1f99ac",
  null
  
)

export default component.exports